import { IQueryKeyValue } from '../../models/commonTypes';

export default function normalizeQueryResults(
    result: IQueryKeyValue,
    preserveValueKey: boolean = false
) {
    for (const key of Object.keys(result)) {
        if (result[key]) {
            if (preserveValueKey) {
                if (result[key].value === undefined) {
                    result[key].value = result[key];
                }
            } else {
                if (result[key].value !== undefined) {
                    result[key] = result[key].value;
                }
            }
        }
    }
    return result;
}



// WEBPACK FOOTER //
// ./src/utils/query/normalizeQueryResults.ts